import React from "react";

export function ProductSupplierColumn(cellContent, row) {
    return (
        <>
                <span className="text-hover-primary mb-1 font-size-lg">
                    {row.supplier[0].entityName}
                </span>
        </>
    );
}

